import styled from '@emotion/styled';

import { endDirection } from 'app/styles/selectors/markup';

const S = {};

S.Icon = styled.svg`
  label: Icon;
  
  height: 1rem;
  margin-${endDirection}: 0.25rem;
  fill: currentColor;
`;

export default S;
